<template>
  <div id="app">
    <DetailsComponent :data="productData" :view="viewDetail"/>
    <searchComponent :view="viewSearch"/>
    <topComponent :view="viewTop" :data="topData"/>
    <SidebarMenuComponent :view="viewSidebar" @sideBarStatus="showOrHideSidebar" :categories="categories"/>
    <HeaderComponent @sideBarStatus="showOrHideSidebar" v-show="viewBar"/>
    <div class="flame-icon" v-if="topData.length > 0" @click="viewTop = true">
      <i id="big-flame" class="fas fa-fire animate__animated animate__tada animate__infinite red"></i>
      <i id="medium-flame" class="fas fa-fire animate__animated animate__tada animate__infinite"></i>
      <i id="small-flame" class="fas fa-fire animate__animated animate__jello animate__infinite yellow"></i>
    </div>
    <div id="container">
      <div :id="'category-' + categorySlug(category)" class="category" :key="category" v-for="(data, category, index) in catalogData.categories">
        <a :name="categorySlug(category)" class="ancla-navegacion"></a>
        <ModuleComponent :key="key" v-for="(module,key) in data.modules" :data="module" :category="category" :page="index + 1" :menu="menuData" :indice="key"/>
      </div>
    </div>
    <!--<ScrollBarComponent :categories="catalogData.categories" :position="positionY" :indice="indiceAr"/>-->
  </div>
</template>

<script>
/* eslint-disable */
import HeaderComponent from './components/HeaderComponent'
import SearchComponent from './components/SearchComponent'
import TopComponent from './components/TopComponent'
import SidebarMenuComponent from './components/SidebarMenuComponent'
import DetailsComponent from './components/DetailsComponent'
import ModuleComponent from './components/ModuleComponent'
import ScrollBarComponent from './components/ScrollBarComponent'

const axios = require('axios')
var scrollTimer
export default {
  name: 'App',
  data () {
    return {
      viewSidebar: false,
      viewDetail: false,
      viewSearch: false,
      viewTop: false,
      catalogData: {},
      menuData:{},
      productData: {},
      productsData: {},
      productDataShare: {},
      topData: [],
      categories: [],
      viewBar: true,
      indice: [],
      indiceAr: [],
      isMobile: false,
      positionY: 0,
      pageNumber: 0,
      pageWidth: 0,
      pageHeight: 0,
      desktopScrollBarX: 27
    }
  },
  methods: {
    categorySlug(cat){
      cat = cat.replace(/ /g, '-');
      cat = cat.replace(/á/g, 'a');
      cat = cat.replace(/é/g, 'e');
      cat = cat.replace(/í/g, 'i');
      cat = cat.replace(/ó/g, 'o');
      cat = cat.replace(/ú/g, 'u');
      cat = cat.replace(/Á/g, 'a');
      cat = cat.replace(/É/g, 'e');
      cat = cat.replace(/Í/g, 'i');
      cat = cat.replace(/Ó/g, 'o');
      cat = cat.replace(/Ú/g, 'u');
      cat = cat.replace(/ñ/g, 'n');
      cat = cat.replace(/Ñ/g, 'N');
      return cat;
    },
    onScroll () {
      window.clearTimeout(scrollTimer)
      this.viewBar = true
      // eslint-disable-next-line
      scrollTimer = setTimeout(() => this.viewBar = true, 500)
      this.positionY = window.scrollY
      //return 
    },
    showOrHideSidebar () {
      if(!this.viewSidebar){
        dataLayer.push({
        'event': 'Interacción', // Acá se deja como evento de interacción
        'category': 'Índice', // Especificar que hace referencia al Índice
        'action': 'Click', // Se registra la acción como un clic
        'tag': 'Apertura' // A qué se le hizo clic
        });
      }
      this.viewSidebar = this.viewSidebar ? false : true
    },
    openDetail (sku) {
      this.productData = this.productsData[sku]
      this.viewDetail = true
    },
    changeCoordinates (data) {
      let insertHeight
      let insertWidth
      if(this.isMobile){
        insertWidth  = window.innerWidth
        insertHeight = (insertWidth * 1334) / 750
      }else{
        insertHeight = window.innerHeight - this.desktopScrollBarX
        insertWidth  = (insertHeight * 750) / 1334
      }
      this.pageWidth = insertWidth
      this.pageHeight = insertHeight
      //let placeholder = document.getElementById('placeholder-img')
      let plus = 0//(!this.isMobile) ? 0.99 : 0.96
      //let insertHeight = window.innerHeight * plus //placeholder.offsetHeight * plus
      console.log(insertHeight)
      //document.body.removeChild(placeholder)
      let positionScroll = 0
      Object.entries(data.categories).forEach(element => {
        if(typeof element[0] === "string"){
          let slug = element[0].replace(/ /g, '-');
          slug = slug.replace(/á/g, 'a');
          slug = slug.replace(/é/g, 'e');
          slug = slug.replace(/í/g, 'i');
          slug = slug.replace(/ó/g, 'o');
          slug = slug.replace(/ú/g, 'u');
          slug = slug.replace(/Á/g, 'a');
          slug = slug.replace(/É/g, 'e');
          slug = slug.replace(/Í/g, 'i');
          slug = slug.replace(/Ó/g, 'o');
          slug = slug.replace(/Ú/g, 'u');
          slug = slug.replace(/ñ/g, 'n');
          slug = slug.replace(/Ñ/g, 'N');
          this.indice[slug] = positionScroll
          this.indiceAr.push({'cat':element[0],'posY':positionScroll})
        }
        
        element[1].modules.forEach((module, key) => {
          if (module.type === 'insert') {
            if(module.originalWidth > 750){
              insertWidth = Math.round((insertHeight * module.originalWidth) / module.originalHeight)
            }else{
              insertWidth  = this.isMobile ? window.innerWidth : (insertHeight * 750) / 1334
            }
            module.myWidth = insertWidth
            if (module.content.products) {
              module.content.products.forEach(coordinates => {
                coordinates.positionX = Math.round((insertWidth * coordinates.positionX) / module.originalWidth)
                coordinates.positionY = Math.round((insertHeight * coordinates.positionY) / module.originalHeight)
              })
            }
            if (module.content.links) {
              let restoMbY = this.isMobile ? 0 : 0;
              let restoMbX = 0//this.isMobile ? 30 : 0;
              console.log("WIDTH")
              console.log(insertWidth)
              console.log("HEIGHT")
              console.log(insertHeight)
              module.content.links.forEach(coordinates => {
                coordinates.positionX = Math.round(((insertWidth - restoMbX) * coordinates.positionX) / module.originalWidth)
                coordinates.positionY = Math.round(((insertHeight-restoMbY) * coordinates.positionY) / module.originalHeight)
              })
            }
            if(module.content.menus){
              module.content.menus.forEach(coordinates => {
                coordinates.positionX = Math.round((insertWidth * coordinates.positionX) / module.originalWidth)
                coordinates.positionY = Math.round((insertHeight * coordinates.positionY) / module.originalHeight)
                coordinates.sizeW = Math.round((insertWidth * coordinates.sizeW)/module.originalWidth)
                coordinates.sizeH = Math.round((insertHeight * coordinates.sizeH)/module.originalHeight)
              })
            }
            if(!this.isMobile){
            positionScroll += insertWidth + 10
            }else{
              positionScroll += insertHeight
            }
          } else {
            if (!this.isMobile) {
              let calculateWidth = (Math.ceil(module.content.items.length / 2)) * 250
              positionScroll += calculateWidth + 40
            }else{
              let calculateHeight = (Math.ceil(module.content.items.length / 2)) * 335
              console.log(calculateHeight)
              positionScroll += calculateHeight + 30
            }
          }
        })
      })
      console.log(data)
      return data
    }
  },
  components: {
    HeaderComponent,
    SidebarMenuComponent,
    DetailsComponent,
    ModuleComponent,
    SearchComponent,
    TopComponent,
    ScrollBarComponent,
  },
  mounted () {
    this.isMobile = (window.screen.width >= 1000) ? false : true
    window.addEventListener('scroll', this.onScroll)
    let jsonFile = $('#jsonfile').data()
    axios
      .get('/static/'+jsonFile.json+'.json')
      .then((response) => {
        this.catalogData = this.changeCoordinates(response.data)
        this.productsData = this.catalogData.products
        this.topData = this.catalogData.tops
        this.categories = response.data.categories
        this.menuData = response.data.menu
        console.log("Menu data:",this.menuData)
        setInterval(function () {
          if(document.querySelectorAll('.hotspot')){
            animateCSS('.hotspot', 'bounceIn')
          }
        }, 6000)
      })
      if(!this.isMobile){
        const scrollContainer = document.getElementById('container');
        scrollContainer.addEventListener('wheel', (evt) => {
          evt.preventDefault();
          scrollContainer.scrollLeft += evt.deltaY;
        });
      }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
const animateCSS = (element, animation, prefix = 'animate__') =>
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`
    const node = document.querySelectorAll(element)

    node.forEach(element => {
      element.classList.add(`${prefix}animated`, animationName)
    })

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd (event) {
      event.stopPropagation()
      node.forEach(element => {
        element.classList.remove(`${prefix}animated`, animationName)
      })
      resolve('Animation ended')
    }
    if(node[0]){
      node[0].addEventListener('animationend', handleAnimationEnd, {once: true})
    }
  })
  
</script>

<style>
html,body{max-width:100%;overflow-x:hidden;}
#app {
  font-family: 'Montserrat', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.flame-icon{
  width: 55px;
  padding-bottom: 10px;
  padding-top: 10px;
  position: fixed!important;
  bottom: 20px;
  background-color: #fff;
  border-radius: 100px;
  right: 20px;
  z-index: 103;
  color: #ff7d00;
  -webkit-box-shadow: 0px 2px 6px 1px #ff4300fa;
  box-shadow: 0px 2px 6px 1px #ff4300fa;
  
}
i#small-flame {
    position: absolute;
    bottom: 7px;
    right: 16px;
    opacity: .8;
    font-size: 1.750em;
}
i#medium-flame {
    position: absolute;
    bottom: 9px;
    right: 16px;
    opacity: .8;
    font-size: 1.800em;
}
#big-flame{
  font-size:2em;
}
i.red{color:#f00}
i.yellow {
    color: #ffe100;
}
.icon-drag {
    position: absolute;
    z-index: 2000000;
    filter: brightness(1.1);
    mix-blend-mode: multiply;
    left: 198px;
    top: 316px;
}
.circle-click {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    background-color:rgba(255,255,255,.5);
    width: 1px;
    height: 1px;
    z-index: 3;
    animation-name: 'ripple';
    animation-duration: 0.5s;
    animation-timing-function: ease-in;
    }
    @keyframes ripple {
    0% {
    transform: scale(0, 0);
    opacity: 0;
    }
    75% {
    transform: scale(450, 450);
    opacity: 0.75;
    }
    100% {
    transform: scale(700, 700);
    opacity: 1;
    }
    }
@media only screen and (min-width: 1000px) {
  html,body{max-width:auto;overflow-x:auto;}
  #app {margin-top:0px!important}
  #container{
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  height:100vh;
  }
  .category:first-child{margin-left:60px}
  .category,.ancla-navegacion{flex: 0 0 auto;}
  /* width */
  ::-webkit-scrollbar {
    width: 15px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px grey; 
    border-radius: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: red; 
    border-radius: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue